import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { inr } from "../lib/api";
import { toast } from "sonner";

const field = "w-full h-10 px-3 rounded-md border border-input bg-card text-sm num focus:outline-none focus:ring-2 focus:ring-ring";
const r2 = (n) => Math.round((n || 0) * 100) / 100;

export const StorePartialDialog = ({ bill, onClose, onSubmit }) => {
  const hasStore = bill.paid_cash != null || bill.paid_online != null;
  const [cash, setCash] = useState(hasStore ? String(bill.paid_cash ?? r2(bill.amount - (bill.paid_online || 0))) : "");
  const [online, setOnline] = useState(hasStore ? String(bill.paid_online ?? r2(bill.amount - (bill.paid_cash || 0))) : "");
  const [method, setMethod] = useState(bill.online_method || "bank");
  const [busy, setBusy] = useState(false);
  const total = r2((parseFloat(cash) || 0) + (parseFloat(online) || 0));
  const ok = Math.abs(total - bill.amount) < 0.01;
  const onCash = (v) => { setCash(v); setOnline(String(Math.max(r2(bill.amount - (parseFloat(v) || 0)), 0))); };
  const go = async () => {
    if (!ok) return toast.error(`Cash + ${method.toUpperCase()} must equal ${inr(bill.amount)}`);
    setBusy(true);
    await onSubmit({ paid_cash: parseFloat(cash) || 0, paid_online: parseFloat(online) || 0, online_method: method });
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="store-partial-dialog" className="max-w-md">
        <DialogHeader><DialogTitle className="font-display text-2xl">Partial payment · bill {bill.bill_no}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">{hasStore ? "Amounts filled from the store bill — correct them if needed." : "The store didn't send the split. Enter how it was paid."}</p>
        <div className="grid grid-cols-2 gap-3">
          <div><label className="text-sm font-medium block mb-1">Cash (₹)</label>
            <input data-testid="store-partial-cash" type="number" className={field} value={cash} onChange={(e) => onCash(e.target.value)} /></div>
          <div><label className="text-sm font-medium block mb-1">Online (₹)</label>
            <input data-testid="store-partial-online" type="number" className={field} value={online} onChange={(e) => setOnline(e.target.value)} /></div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {["bank", "qr", "upi"].map((m) => (
            <button key={m} type="button" data-testid={`store-partial-method-${m}`} onClick={() => setMethod(m)}
              className={`h-9 rounded-md text-xs uppercase border transition-colors ${method === m ? "bg-primary text-primary-foreground border-primary" : "bg-card border-input hover:bg-muted"}`}>{m}</button>
          ))}
        </div>
        <div data-testid="store-partial-formula" className={`text-sm num ${ok ? "text-muted-foreground" : "text-destructive"}`}>
          Cash {inr(parseFloat(cash) || 0)} + {method.toUpperCase()} {inr(parseFloat(online) || 0)} = {inr(total)} {ok ? "✓" : `(bill ${inr(bill.amount)})`}
        </div>
        <DialogFooter>
          <button data-testid="store-partial-submit" disabled={busy} onClick={go} className="h-10 px-5 rounded-md bg-accent text-accent-foreground text-sm disabled:opacity-50">{busy ? "Adding…" : "Add Outside Invoice"}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const StoreModeBadge = ({ b, cls }) => (
  <div>
    <span className={`text-xs px-2 py-0.5 rounded-full font-medium uppercase ${cls}`}>{b.payment_mode}</span>
    {b.payment_mode === "partial" && (b.paid_cash != null || b.paid_online != null) && (
      <div data-testid={`store-mode-split-${b.bill_no}`} className="text-[11px] text-muted-foreground num mt-1 whitespace-nowrap">
        Cash {inr(b.paid_cash || 0)} + {(b.online_method || "bank").toUpperCase()} {inr(b.paid_online || 0)}
      </div>
    )}
  </div>
);
